import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import { Permission } from '../models/permission';

@Injectable()
export class PermissionsService extends BaseHttpService<Permission> {

  constructor() {
    super('permissions');
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data/permissions.service.ts